<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

        <b-card-body>
            <b-card bg-variant="light">

                <div v-if="loading" class="text-center my-5">
                    <b-spinner label="Carregando..."></b-spinner>
                </div>

                <b-tabs v-else>
                    <b-tab active>
                        <template v-slot:title>
                            <b-icon icon="file-earmark-plus" variant="primary"></b-icon>
                            Contrato
                        </template>
                        <ContratoForm :idFinderContrato="idFinderContrato" :processoCompra="processoCompra"
                            :prefix="prefix + title + ' > '" :contratoFormParam.sync="contratoForm"
                            :isEditMode="isEditMode" @contratoFormSubmit="contratoFormSubmit" />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="building" variant="primary"></b-icon>
                            Empresa
                        </template>
                        <EmpresaForm :prefix="prefix + title + ' > '" :contratoFormParam.sync="contratoForm"
                            :isEditMode="isEditMode" @contratoFormSubmit="contratoFormSubmit" />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="collection" variant="primary"></b-icon>
                            Itens
                        </template>
                        <ItemForm :processoCompra="processoCompra" :prefix="prefix + title + ' > '"
                            :contratoFormParam.sync="contratoForm" :isEditMode="isEditMode"
                            @contratoFormSubmit="contratoFormSubmit" />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="calendar" variant="primary"></b-icon>
                            Vigências
                        </template>
                        <VigenciasForm :prefix="prefix + title + ' > '" :contratoFormProp.sync="contratoForm"
                            :isEditMode="isEditMode" />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="file-earmark-text" variant="primary"></b-icon>
                            Aditivos
                        </template>
                        <AditivosForm :prefix="prefix" :contratoFormProp.sync="contratoForm" :isEditMode="isEditMode" />
                    </b-tab>

                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="cash-stack" variant="primary"></b-icon>
                            Financeiro
                        </template>
                        <FinanceiroContratosForm :prefix="prefix" :contratoFormProp.sync="contratoForm"
                            :isEditMode="isEditMode" />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="people-fill" variant="primary"></b-icon>
                            Responsáveis pelo Contrato
                        </template>
                        <ResponsaveisFiscaisForm :prefix="prefix" :contratoFormProp.sync="contratoForm"
                            :isEditMode="isEditMode" />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="building" variant="primary"></b-icon>
                            Orgãos Fiscalizadores
                        </template>
                        <OrgaosContratosForm :prefix="prefix" :contratoFormProp.sync="contratoForm"
                            :isEditMode="isEditMode" />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <b-icon icon="journal-text" variant="primary"></b-icon>
                            Empenho
                        </template>
                        <EmpenhoForm :prefix="prefix + title" :contratoFormParam.sync="contratoForm"
                            :isEditMode="isEditMode" @contratoFormSubmit="contratoFormSubmit" />
                    </b-tab>

                </b-tabs>
                <b-row class="mt-3">
                    <b-col cols="12" class="d-flex justify-content-center">
                        <b-button variant="primary" size="sm" pill @click="onSubmit">
                            <b-icon icon="check-circle" />
                        </b-button>
                        <b-button variant="danger" size="sm" pill @click="cancelar">
                            <b-icon icon="x-circle" />
                        </b-button>

                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
    </b-modal>
</template>

<script>
import ContratoForm from "@/modules/contratos/components/ContratoForm.vue";
import EmpenhoForm from "@/modules/contratos/components/EmpenhoForm.vue";
import VigenciasForm from "@/modules/contratos/components/VigenciasForm.vue";
import AditivosForm from "@/modules/contratos/components/AditivosForm.vue";
import FinanceiroContratosForm from "@/modules/contratos/components/FinanceiroContratosForm.vue";
import ContratoService from "@/core/api/ContratoService";
import Swal from "sweetalert2";
import ResponsaveisFiscaisForm from "@/modules/contratos/components/ResponsaveisFiscaisForm.vue";
import OrgaosContratosForm from "@/modules/contratos/components/OrgaosContratosForm.vue";
import EmpresaForm from "@/modules/contratos/components/EmpresaForm.vue";
import ItemForm from "./components/ItemForm.vue";
import TipoAditivoEnum from "@/core/utils/TipoAditivoEnum";

export default {
    name: "ContratoFormRequest",
    components: {
        ItemForm,
        EmpresaForm,
        OrgaosContratosForm,
        ResponsaveisFiscaisForm,
        ContratoForm,
        VigenciasForm,
        AditivosForm,
        FinanceiroContratosForm,
        EmpenhoForm
    },
    props: {
        idFinderContrato: {
            type: String,
            default: ''
        },

        processoCompra: {
            type: Object,
            default: null
        },


        id: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loading: false,
            showModal: true,
            title: "Cadastrar",
            contratoForm: {
                id: null,
                numeroContrato: "",
                renovavel: 0,
                tipoContrato: null,
                tipoContratoId: null,
                modalidadeContrato: null,
                modalidadeContratoId: null,
                grupoContrato: null,
                grupoContratoId: null,
                tipoOrigem: null,
                tipoOrigemId: null,
                contratadas: [],
                contratadasIds: [],
                unidadeAdministrativa: null,
                unidadeAdministrativaId: null,
                situacaoContrato: null,
                processo: "",
                foro: "",
                resumo: "",
                objetoDetalhado: "",
                dataAssinatura: "",
                observacao: "",
                empenhos:[],
                vigencias: [],
                aditivos: [],
                financeiroContratos: [],
                responsaveisFiscais: [],
                orgaosContratos: [],
                itensContratos: [],
            },
            isEditMode: false,
        };
    },
    methods: {

        cancelar() {
            this.$emit("close");
        },

        contratoFormSubmit(contrato) {
            this.contratoForm = {
                ...this.contratoForm,
                ...contrato,
            };
        },
        updateVigencias(vigencias) {
            this.contratoForm.vigencias = vigencias;
        },
        updateAditivos(aditivos) {
            this.contratoForm.aditivos = aditivos;
        },
        updateFinanceiroContratos(financeiros) {
            this.contratoForm.financeiroContratos = financeiros;
        },
        updateResponsaveisFiscais(responsaveis) {
            this.contratoForm.responsaveisFiscais = responsaveis;
        },
        updateOrgaosContratos(orgaos) {
            this.contratoForm.orgaosContratos = orgaos;
        },
        async onSubmit() {

            if (!this.contratoForm.numeroLicitacao || this.contratoForm.numeroLicitacao == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o número da licitação",
                });
                return;
            }

            if (!this.contratoForm.tipoRequisicaoCompra || !this.contratoForm.tipoRequisicaoCompra.id) {
                this.$notify({
                    type: "danger",
                    message: "Selecione o tipo de compra",
                });

                return;
            }

            if (this.contratoForm.tipoRequisicaoCompra && this.contratoForm.tipoRequisicaoCompra.id && this.contratoForm.tipoRequisicaoCompra.id == 2 && (!this.contratoForm.modalidadeContrato || !this.contratoForm.modalidadeContrato.id)) {
                this.$notify({
                    type: "danger",
                    message: "Selecione a modalidade do contrato",
                });

                return;
            }
            if (!this.contratoForm.tipoContrato || !this.contratoForm.tipoContrato.id) {
                this.$notify({
                    type: "danger",
                    message: "Selecione o tipo do contrato",
                });

                return;
            }


            if (!this.contratoForm.grupoContrato || !this.contratoForm.grupoContrato.id) {
                this.$notify({
                    type: "danger",
                    message: "Selecione a  categoria do contrato",
                });

                return;
            }


            if (!this.contratoForm.numeroLicitacao || this.contratoForm.numeroLicitacao == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o número da licitação",
                });
                return;
            }


            if (!this.contratoForm.dataAssinatura || this.contratoForm.dataAssinatura == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a data de assinatura",
                });
                return;
            }


            if (!this.contratoForm.dataLimite || this.contratoForm.dataLimite == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a data de limite",
                });
                return;
            }


            if (!this.contratoForm.dataProposta || this.contratoForm.dataProposta == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a data de proposta",
                });
                return;
            }

            if (!this.contratoForm.dataPublicacao || this.contratoForm.dataPublicacao == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite a data de publicação",
                });
                return;
            }



            if (!this.contratoForm.unidadeAdministrativa || !this.contratoForm.unidadeAdministrativa.id) {
                this.$notify({
                    type: "danger",
                    message: "Selecione a unidade administrativa",
                });

                return;
            }


            if (!this.contratoForm.processo || this.contratoForm.processo == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o processo",
                });
                return;
            }

            if (!this.contratoForm.foro || this.contratoForm.foro == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o foro",
                });
                return;
            }

            if (!this.contratoForm.resumo || this.contratoForm.resumo == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o objeto resumido",
                });
                return;
            }

            if (!this.contratoForm.objetoDetalhado || this.contratoForm.objetoDetalhado == "") {
                this.$notify({
                    type: "danger",
                    message: "Digite o objeto detalhado",
                });
                return;
            }



            if (!this.contratoForm.contratadas || this.contratoForm.contratadas.length == 0) {

                this.$notify({
                    type: "danger",
                    message: "É necessário escolher ao menos uma empresa",
                });
                return;
            }


            if (!this.contratoForm.itensContratos || this.contratoForm.itensContratos.length == 0) {

                this.$notify({
                    type: "danger",
                    message: "É necessário escolher ao menos um produto",
                });
                return;
            }

            var itemInvalido = this.contratoForm.itensContratos.some(item => !item.quantidade || !item.valorUnitario);

            if (itemInvalido) {
                this.$notify({
                    type: "danger",
                    message: "É necessário o valor e a quantidade de todos os itens",
                });
                return;

            }


            if (!this.contratoForm.vigencias || this.contratoForm.vigencias.length == 0) {

                this.$notify({
                    type: "danger",
                    message: "É necessário criar ao menos uma vigência",
                });
                return;
            }

            itemInvalido = this.contratoForm.vigencias.some(item => !item.dataInicial || item.dataInicial == "" || !item.dataFinal || item.dataFinal == "" || !item.tipoVigencia || !item.tipoVigencia.id);

            if (itemInvalido) {
                this.$notify({
                    type: "danger",
                    message: "É necessário preencher todas as informações da vigência",
                });
                return;

            }


            if (this.contratoForm.aditivos && this.contratoForm.aditivos.length > 0) {
                itemInvalido = this.contratoForm.aditivos.some(item =>
                    !item.tipoAditivo || !item.tipoAditivo.id ||
                    (item.tipoAditivo.id == TipoAditivoEnum.PRORROGACAO_PRAZO.cod && (!item.dataInicial || item.dataInicial == "" || !item.dataFinal || item.dataFinal == "")) ||
                    (item.tipoAditivo.id != TipoAditivoEnum.PRORROGACAO_PRAZO.cod && (!item.valorAnterior || item.valorAnterior == "" || !item.valorNovo || item.valorNovo == ""))
                );
                if (itemInvalido) {
                    this.$notify({
                        type: "danger",
                        message: "É necessário preencher todas as informações do Aditivo",
                    });
                    return;

                }

            }


            itemInvalido = this.contratoForm.financeiroContratos && this.contratoForm.financeiroContratos.length > 0 && this.contratoForm.financeiroContratos.some(item =>
                !item.valorAntigo || item.valorAntigo == "" ||
                !item.valor || item.valor == "" || !item.tipoValor || !item.tipoValor.id || !item.tipoAlteracao || !item.tipoAlteracao.id ||
                !item.dataAutorizacao || item.dataAutorizacao == "" ||
                !item.dataVigencia || item.dataVigencia == ""
            );
            if (itemInvalido) {
                this.$notify({
                    type: "danger",
                    message: "É necessário preencher todas as informações do registro financeiro",
                });
                return;

            }

            if (!this.contratoForm.responsaveisFiscais || this.contratoForm.responsaveisFiscais.length == 0) {

                this.$notify({
                    type: "danger",
                    message: "É necessário criar ao menos um Responsável Fiscal",
                });
                return;
            }

            itemInvalido = this.contratoForm.responsaveisFiscais.some(item =>
                !item.dataInicial || item.dataInicial == "" ||
                !item.dataFinal || item.dataFinal == "" || !item.tipoFiscal || !item.tipoFiscal.id || !item.pessoa || !item.pessoa.id
            );

            if (itemInvalido) {
                this.$notify({
                    type: "danger",
                    message: "É necessário preencher todas as informações do Responsável fiscal",
                });
                return;

            }

            if (!this.contratoForm.orgaosContratos || this.contratoForm.orgaosContratos.length == 0) {

                this.$notify({
                    type: "danger",
                    message: "É necessário criar ao menos um Orgão Fiscalizador",
                });
                return;
            }


            itemInvalido = this.contratoForm.orgaosContratos.some(item => !item.departamento || !item.departamento.id || !item.tipoOrgao || !item.tipoOrgao.id);

            if (itemInvalido) {
                this.$notify({
                    type: "danger",
                    message: "É necessário preencher todas as informações do Orgão Fiscalizador",
                });
                return;

            }

            if (!this.contratoForm.empenhos || this.contratoForm.empenhos.length == 0) {

                this.$notify({
                    type: "danger",
                    message: "É necessário escolher ao menos um empenho",
                });
                return;
            }


            try {
                const contratoData = {
                    processoCompra: this.processoCompra != null ? this.processoCompra.id : null,
                    numeroLicitacao: this.contratoForm.numeroLicitacao,
                    renovavel: Number(this.contratoForm.renovavel),
                    tipoRequisicaoCompraId: this.contratoForm.tipoRequisicaoCompra.id,
                    numeroContrato: this.contratoForm.numeroContrato,
                    modalidadeContratoId: this.contratoForm.modalidadeContrato && this.contratoForm.modalidadeContrato.id ? this.contratoForm.modalidadeContrato.id : null,
                    tipoContratoId: this.contratoForm.tipoContrato.id,
                    garantiaContrato: this.contratoForm.garantiaContrato && this.contratoForm.garantiaContrato.id ? this.contratoForm.garantiaContrato : null,
                    grupoContratoId:
                        this.contratoForm.grupoContrato && this.contratoForm.grupoContrato.id ? this.contratoForm.grupoContrato.id : null,
                    unidadeAdministrativaId:
                        this.contratoForm.unidadeAdministrativa && this.contratoForm.unidadeAdministrativa.id ? this.contratoForm.unidadeAdministrativa.id : null,
                    situacaoContrato: this.contratoForm.situacaoContrato,
                    processo: this.contratoForm.processo,
                    contratoAntecessor: this.contratoForm.contratoAntecessor && this.contratoForm.contratoAntecessor.id ? this.contratoForm.contratoAntecessor : null,
                    contratoSucessor: this.contratoForm.contratoSucessor && this.contratoForm.contratoSucessor.id ? this.contratoForm.contratoSucessor : null,
                    foro: this.contratoForm.foro,
                    resumo: this.contratoForm.resumo,
                    objetoDetalhado: this.contratoForm.objetoDetalhado,
                    dataAssinatura: this.contratoForm.dataAssinatura,
                    dataLimite: this.contratoForm.dataLimite,
                    dataProposta: this.contratoForm.dataProposta,
                    dataPublicacao: this.contratoForm.dataPublicacao,
                    contratadasIds: this.contratoForm.contratadas.map((contratada) => contratada.id),
                    empenhosIds: this.contratoForm.empenhos.map((empenho) => empenho.id),

                    vigencias: this.contratoForm.vigencias.map((vigencia) => ({
                        id: vigencia.id ? vigencia.id : null,
                        tipoVigencia: vigencia.tipoVigencia,
                        dataInicial: vigencia.dataInicial,
                        dataFinal: vigencia.dataFinal,
                        observacao: vigencia.observacao,
                        situacao: vigencia.situacao !== null && vigencia.situacao !== undefined ? Number(vigencia.situacao) : 0,
                    })),
                    aditivos: this.contratoForm.aditivos.map((aditivo) => ({
                        ...(aditivo.id && { id: aditivo.id }),
                        tipoAditivo: aditivo.tipoAditivo,
                        valorAnterior: aditivo.valorAnterior,
                        valorNovo: aditivo.valorNovo,
                        numeroAditivo: aditivo.numeroAditivo,
                        dataInicial: aditivo.dataInicial,
                        dataFinal: aditivo.dataFinal,
                        observacao: aditivo.observacao,
                    })),
                    financeiroContratos: this.contratoForm.financeiroContratos.map((financeiro) => ({
                        ...(financeiro.id !== undefined && { id: financeiro.id }),
                        valor: financeiro.valor,
                        valorAntigo: financeiro.valorAntigo,
                        tipoAlteracao: financeiro.tipoAlteracao,
                        tipoValorId:
                            financeiro.tipoValor.id,
                        observacao: financeiro.observacao,
                        situacao: Number(financeiro.situacao),
                        dataAutorizacao: financeiro.dataAutorizacao,
                        dataVigencia: financeiro.dataVigencia,
                    })),
                    responsaveisFiscais: this.contratoForm.responsaveisFiscais.map((responsavel) => ({
                        ...(responsavel.id && { id: responsavel.id }),
                        idPessoa:
                            (responsavel.pessoa.id),
                        observacao: responsavel.observacao,
                        tipoFiscal: responsavel.tipoFiscal,
                        dataInicial: responsavel.dataInicial,
                        dataFinal: responsavel.dataFinal,
                        situacao: Number(responsavel.situacao),
                    })),
                    orgaosContratos: this.contratoForm.orgaosContratos.map((orgaoContrato) => ({
                        ...(orgaoContrato.id && { id: orgaoContrato.id }),
                        idDepartamento:
                            (orgaoContrato.departamento.id),
                        idTipoOrgao:
                            (orgaoContrato.tipoOrgao.id),
                    })),
                    itensContratos: this.contratoForm.itensContratos.map((item) => ({
                        ...(item.id && { id: item.id }),
                        produto: item.produto,
                        codItemProcessoCompra: item.codItemProcessoCompra,
                        quantidade: item.quantidade,
                        valorUnitario: item.valorUnitario,
                    })),
                };

                if (this.isEditMode) {
                    await ContratoService.update(this.contratoForm.id, contratoData);
                    Swal.fire({
                        icon: "success",
                        title: "Sucesso",
                        text: "Contrato atualizado com sucesso",
                    });
                } else {
                    await ContratoService.create(contratoData);
                    Swal.fire({
                        icon: "success",
                        title: "Sucesso",
                        text: "Contrato criado com sucesso",
                    });
                }

                this.cancelar();
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Erro",
                    text: "Ocorreu um erro ao salvar o contrato",
                });
                console.error("Erro ao salvar contrato:", error);
            }
        },

        async carregarContrato(id) {
            this.loading = true;
            const response = await ContratoService.findById(id);
            const data = response.data;

            this.contratoForm = {
                ...data,
                renovavel: Number(data.renovavel),
                tipoRequisicaoCompra: data.tipoRequisicaoCompra,
                tipoRequisicaoCompraId: data.tipoRequisicaoCompra.id,
                tipoContratoId: data.tipoContrato && data.tipoContrato.cod ? data.tipoContratoId : null,
                tipoContrato: data.tipoContrato && data.tipoContrato.id ? data.tipoContrato : {},
                modalidadeContratoId: (data.modalidadeContrato && data.modalidadeContrato.id) ? data.modalidadeContrato.cod : null,
                modalidadeContrato: data.modalidadeContrato && data.modalidadeContrato.id ? data.modalidadeContrato : {},
                grupoContratoId: (data.grupoContrato && data.grupoContrato.cod) || data.grupoContratoId,
                unidadeAdministrativaId: (data.unidadeAdministrativa && data.unidadeAdministrativa.id) || data.unidadeAdministrativaId,
                contratadasIds: (data.contratadas && data.contratadas.map((contratada) => contratada.id)) || [],
                empenhosIds: (this.contratoForm.empenhos.map((empenho) => empenho.id)) || [],

                vigencias: !data.vigencias || data.vigencias.length == 0 ? [] : data.vigencias.map((vigencia) => {
                    return {
                        id: vigencia.id,
                        tipoVigencia: vigencia.tipoVigencia,
                        dataInicial: vigencia.dataInicial,
                        dataFinal: vigencia.dataFinal,
                        observacao: vigencia.observacao,
                        situacao: Number(vigencia.ativa),
                    };
                }),
                aditivos: !data.aditivos || data.aditivos.length == 0 ? [] : data.aditivos.map((aditivo) => {
                    return {
                        id: aditivo.id,
                        tipoAditivo: aditivo.tipoAditivo,
                        valorAnterior: aditivo.valorAnterior,
                        valorNovo: aditivo.valorNovo,
                        numeroAditivo: aditivo.numeroAditivo,
                        dataInicial: aditivo.dataInicial,
                        dataFinal: aditivo.dataFinal,
                        observacao: aditivo.observacao,
                    };
                }),
                financeiroContratos: !data.financeiroContratos || data.financeiroContratos.length == 0 ? [] : data.financeiroContratos.map((financeiro) => {
                    return {
                        dataVigencia: financeiro.dataVigencia,
                        dataAutorizacao: financeiro.dataAutorizacao,
                        id: financeiro.id,
                        valor: financeiro.valor,
                        valorAntigo: financeiro.valorAntigo,
                        tipoValor: financeiro.tipoValor,
                        tipoAlteracao: financeiro.tipoAlteracao,
                        tipoValorId: financeiro.tipoValor && financeiro.tipoValor.id ? financeiro.tipoValor.id : {},
                        observacao: financeiro.observacao,
                        valorGlobal: financeiro.valorGlobal,
                        situacao: Number(financeiro.situacao),
                    };
                }),
                responsaveisFiscais: !data.responsaveisFiscais || data.responsaveisFiscais.length == 0 ? [] : data.responsaveisFiscais.map((responsavel) => {
                    return {
                        id: responsavel.id,
                        pessoa: responsavel.pessoa || null,
                        idPessoa: responsavel.pessoa.id,
                        observacao: responsavel.observacao,
                        tipoFiscal: responsavel.tipoFiscal,

                        dataInicial: responsavel.dataInicial,
                        dataFinal: responsavel.dataFinal,
                        situacao: Number(responsavel.situacao),
                    };
                }),
                orgaosContratos: !data.orgaosContratos || data.orgaosContratos.length == 0 ? [] : data.orgaosContratos.map((orgaoContrato) => {
                    return {
                        id: orgaoContrato.id,
                        departamento: orgaoContrato.departamento || null,
                        idDepartamento: (orgaoContrato.departamento && orgaoContrato.departamento.id) || orgaoContrato.idDepartamento,
                        tipoOrgao: orgaoContrato.tipoOrgao || null,
                        idTipoOrgao: (orgaoContrato.tipoOrgao && orgaoContrato.tipoOrgao.cod) || orgaoContrato.idTipoOrgao,
                    };
                }),
                itensContratos: !data.itensContratos || data.itensContratos.length == 0 ? [] : data.itensContratos.map((item) => {
                    return {
                        id: item.id,
                        codItemProcessoCompra: item.codItemProcessoCompra,
                        produto: item.produto,
                        quantidade: item.quantidade,
                        valorUnitario: item.valorUnitario,
                    };
                }),
            };

            this.loading = false;
        },
    },
    beforeMount() {
        const contratoId = this.id;
        this.isEditMode = !!contratoId;
        if (this.isEditMode) {
            this.carregarContrato(contratoId);
        }

    },
};
</script>

<style lang="scss">
a {
    color: #292d32;
}
</style>
